import { render, staticRenderFns } from "./itemorgroupselector.vue?vue&type=template&id=4c4a2079&scoped=true&"
import script from "./itemorgroupselector.vue?vue&type=script&lang=js&"
export * from "./itemorgroupselector.vue?vue&type=script&lang=js&"
import style0 from "./itemorgroupselector.vue?vue&type=style&index=0&id=4c4a2079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a2079",
  null
  
)

export default component.exports